export default __webpack_public_path__ + "static/media/illustration-algowork-m@2x.a3e0c876.webp";